<ng-container *ngIf="isAdmin">
  <ion-header>
    <ion-toolbar color="primary">
      <ion-title>Administrace aukce</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <div class="admin-table-container">
      <div class="export-button-container">
        <ion-button (click)="exportToCSV()" color="secondary">
          <ion-icon name="download-outline" slot="start"></ion-icon>
          Exportovat do CSV
        </ion-button>
      </div>
      <table class="admin-table">
        <thead>
          <tr>
            <th>Dílo</th>
            <th>Autor</th>
            <th>Aktuální cena</th>
            <th>Nejvyšší nabídka</th>
            <th>Počet příhozů</th>
            <th>Historie příhozů</th>
            <th>Akce</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of (currentPhotos | async)">
            <td>
              <div class="artwork-info">
                <img [src]="p.url" alt="{{p.title}}" class="artwork-thumbnail">
                <div class="artwork-details">
                  <strong>{{p.title}}</strong>
                  <small>{{p.sizeDesc}}</small>
                </div>
              </div>
            </td>
            <td>{{p.author}}</td>
            <td>{{p.currentPrice}} Kč</td>
            <td>
              <ng-container *ngIf="p.currentTopper">
                <div class="bidder-info">
                  <span class="bidder-nickname">{{p.currentTopper.name}}</span>
                  <span class="bidder-fullname">
                    ({{ getUserFullNameByEmail(p.currentTopper.email) }})
                  </span>
                </div>
                <span class="bidder-email">({{p.currentTopper.email}})</span>
              </ng-container>
              <ng-container *ngIf="!p.currentTopper">
                Žádné příhozy
              </ng-container>
            </td>
            <td>{{priceHistoryLength(p)}}</td>
            <td class="bid-history">
              <div *ngIf="p.priceHistory">
                <div *ngFor="let price of getSortedPrices(p)" class="bid-history-item">
                  <span class="bid-price">{{price}} Kč</span>
                  <span class="bid-user">
                    {{ getUserNameByEmail(p.priceHistory[price]) }}
                    ({{ p.priceHistory[price] }})
                  </span>
                </div>
              </div>
            </td>
            <td>
              <ion-button 
                color="danger" 
                size="small" 
                (click)="removeLatestBid(p)"
                [disabled]="!p.currentTopper"
              >
                Odebrat poslední příhoz
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ion-content>
</ng-container>
